import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { HashLink as Link } from 'react-router-hash-link';

const ProjectComponent = () => {
    return (
        <div className="coming-soon" id="coming">
            <Container className="py-5 mt-5">
                <Row>
                    <Col md="6">
                        <div className="d-flex align-items-center">
                            <div>
                                <h2 className="title text-white font-weight-bold">Collaborons ensemble !</h2>
                                <h6 className="subtitle font-light text-white">Si vous avez une mission à nous confier ou si vous êtes à la recherche d'une mission </h6>
                                {/* <a href="/#coming" className="btn btn-outline-light m-r-20 btn-md m-t-30 font-14">Comming Soon</a> */}
                                <Link to="/#contact" className="btn btn-outline-light m-r-20 btn-md m-t-30 font-14">Nous contacter</Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ProjectComponent;
